import { render } from "./ACRecovery.vue?vue&type=template&id=145d6d09"
import script from "./ACRecovery.vue?vue&type=script&lang=js"
export * from "./ACRecovery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__